// Blitz DEX — Romanian News Synonym Dictionary
// Add new topic clusters as you notice duplicates slipping through

export const newsDEX = {
  cutremur: ['seism', 'magnitudine', 'richter', 'epicentru', 'aftershock', 'replică'],
  alegeri: ['vot', 'scrutin', 'candidat', 'campanie', 'urnă', 'electorală', 'electoral', 'alegere'],
  accident: ['coliziune', 'impact', 'carambol', 'tamponare', 'răsturnare', 'avarie'],
  incendiu: ['flăcări', 'foc', 'pompieri', 'ardere', 'ars', 'flacără', 'incendiat'],
  inundație: ['inundații', 'viitură', 'revărsare', 'potop', 'alunecare', 'cod roșu', 'cod portocaliu'],
  covid: ['coronavirus', 'pandemic', 'vaccin', 'vaccinare', 'infectare', 'îmbolnăvire', 'spital'],
  război: ['razboi', 'conflict', 'bombardament', 'atac', 'ofensivă', 'invazie', 'ucraina', 'rusia'],
  guvern: ['guvernare', 'premier', 'ministru', 'cabinet', 'coaliție', 'parlament', 'senat', 'camera'],
  economie: ['inflație', 'curs', 'leu', 'euro', 'bursă', 'pib', 'recesiune', 'creștere economică'],
  sport: ['fotbal', 'meci', 'victorie', 'înfrângere', 'egal', 'goluri', 'campionat', 'liga'],
  crimă: ['crimă', 'omor', 'asasinat', 'ucis', 'mort', 'cadavru', 'investigație', 'dosar penal'],
  protest: ['manifestație', 'demonstrație', 'marș', 'grevă', 'nemulțumire', 'strada'],
  temperatură: ['caniculă', 'căldură', 'ger', 'îngheț', 'ninsoare', 'ninge', 'vreme', 'meteo', 'prognoza'],
  corupție: ['dosar', 'dna', 'arest', 'reținut', 'condamnat', 'judecată', 'tribunal', 'anticorupție'],
};

// Romanian stop words to strip before keyword matching
export const stopWords = new Set([
  'și', 'că', 'cu', 'din', 'la', 'un', 'o', 'în', 'pe', 'de', 'se', 'sa', 'sau',
  'dar', 'nu', 'mai', 'ca', 'ai', 'ale', 'cel', 'cei', 'cea', 'care',
  'lui', 'lor', 'le', 'li', 'îl', 'îi', 'când', 'unde', 'cum', 'cât', 'cine',
  'este', 'era', 'fi', 'fost', 'face', 'are', 'avea', 'au', 'va', 'vor',
  'după', 'până', 'prin', 'între', 'spre', 'despre', 'pentru', 'dacă', 'iar',
  'deja', 'chiar', 'acum', 'apoi', 'astfel', 'totuși', 'însă', 'deci',
  'the', 'a', 'an', 'is', 'in', 'on', 'at', 'to', 'of', 'and', 'or', 'for',
]);

// Build reverse lookup: word → canonical topic
export const wordToTopic = {};
for (const [topic, synonyms] of Object.entries(newsDEX)) {
  wordToTopic[topic] = topic;
  for (const syn of synonyms) {
    wordToTopic[syn] = topic;
  }
}
